import {useParams} from 'react-router-dom';
import {Box, TextField, Typography} from '@mui/material';
import styles from '../styles';
import moment from 'moment/moment';
import {ITemplate} from '../../../../resource';
import {ThemeSelector} from '../../../../components/ThemeSelector';
import {ImageEditor} from '../../../../components/ImageEditor';
import React, {useContext, useState, useEffect} from 'react';
import {UserSelector} from '../../../../components/UserSelector';
import {AppContext} from '../../../../context';
import {ITheme} from '../../../../resource/interfaces';
import apis from '../../../../apis';

type Props = {
  template?: ITemplate;
  onChange: (value: Partial<ITemplate>) => void;
}

export const BasicInfo = ({
  template,
  onChange,
}: Props) => {
  const { isAdmin } = useContext(AppContext);
  const [themes, setThemes] = useState<ITheme[]>([]);

  useEffect(() => {
    loadThemes();
  }, []);

  const loadThemes = async () => {
    try {
      const result = await apis.theme.getThemes();
      if (result.success) {
        setThemes(result.themes);
      }
    } catch (error) {
      console.error('Failed to load themes:', error);
    }
  };

  // Helper function to get the current color (for backward compatibility)
  const getCurrentColor = (): string => {
    if (template?.theme && themes.length > 0) {
      const themeId = typeof template.theme === 'string' ? template.theme : template.theme._id;
      const theme = themes.find(t => t._id === themeId);
      if (theme) {
        return theme.mainColor;
      }
    }
    return template?.color || '#1976d2';
  };

  return (
    <>
      <Box sx={{ mb: 8 }}>
        <Typography variant="h5" fontWeight={500}>Basic Information</Typography>
      </Box>
      <Box sx={{ width: '100%', display: 'flex', gap: 46 }}>
        <Box sx={styles.template}>
          <ImageEditor
            value={template?.thumbnail_url}
            onChange={(value) => onChange({ thumbnail_url: value })}
          />
        </Box>
        <Box flex={1}>
          <TextField placeholder="Title" sx={styles.titleInput} value={template?.name} onChange={(e) => onChange({ name: e.target.value })} />
          <TextField
            multiline
            placeholder="Description"
            sx={styles.descInput}
            value={template?.description}
            onChange={(e) => onChange({ description: e.target.value })}
          />

          <Typography variant="body2" sx={{ opacity: 0.5, mb: 16 }}>
            {moment(template?.createdAt).format('DD MMMM YYYY / hh:mm:ss')}
          </Typography>

          <ThemeSelector
            selectedThemeId={typeof template?.theme === 'string' ? template.theme : template?.theme?._id}
            onChange={(themeId) => {
              // Update themeId and also update color for backward compatibility
              const selectedTheme = themes.find(t => t._id === themeId);
              onChange({ 
                theme: themeId,
                color: selectedTheme?.mainColor || template?.color || '#1976d2',
                colorSets: selectedTheme?.colorSet?.gradientColors,
              });
            }}
          />

          {isAdmin && (
            <Box sx={{ mt: 8 }}>
              <UserSelector multiple value={template?.userIds || []} onChange={(value) => onChange({ userIds: value })} />
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
};

